import axios from "axios";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://pdf-convertor-api-web-76dac2872150.herokuapp.com/api";


const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Enable sending cookies and auth headers for CORS
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
